import React from "react";
import WishListSection from "../../components/user/WishListSection";
import Layout from "../../components/user/Layout";

function WishlistPage() {
  return (
     <Layout>

      <WishListSection />

    </Layout>
  );
}

export default WishlistPage;
